import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { connectNetworkElement } from '@api/networkElements';

import { INetworkElementsEnableDTO } from '@interfaces/networkElements/dto/networkElements';
import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { ESnackbarTypes } from '@enums/common';

import { NETWORK_ELEMENTS_CONNECT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateNetworkElements from './useInvalidateNetworkElements';

interface IUseMutateNetworkElementsConnectReturned {
	connectNetworkElement: (dto: INetworkElementsEnableDTO) => void;
	isLoadingConnectNetworkElement: boolean;
}

const {
	enableNetworkElement,
	disableNetworkElement,
} = responseMessages;

const useMutateNetworkElementsConnect = (handleCloseModal: () => void): IUseMutateNetworkElementsConnectReturned => {
	const dispatch = useAppDispatch();
	const invalidateNetworkElements = useInvalidateNetworkElements();

	const {
		isLoading,
		mutate,
	} = useMutation<INetworkElementsEnableDTO>({
		mutationKey: [NETWORK_ELEMENTS_CONNECT],
		mutationFn: connectNetworkElement,
		onSuccess: (data: INetworkElement) => {
			const { name, enabled } = data;

			handleCloseModal();

			dispatch(setSnackbar({
				message: enabled ? enableNetworkElement(name) : disableNetworkElement(name),
				type: ESnackbarTypes.success,
			}));

			return invalidateNetworkElements();
		},
	});

	return {
		connectNetworkElement: mutate,
		isLoadingConnectNetworkElement: isLoading,
	};
};

export default useMutateNetworkElementsConnect;
